export const Players = ({ users, recipient, setRecipient }) => {
    return (
        <div className="w-full max-w-sm space-y-2 mt-[50px] mb-[80px]">
            {users.map((u) => (
                <label key={u.player} className="wtext flex items-center space-x-3 text-lg cursor-pointer gray-border border px-4 text-black py-2 rounded">
                    <input
                        type="radio"
                        name="recipient"
                        checked={recipient === u.player}
                        onChange={() => setRecipient(u.player)}
                    />
                    <span className="wtext">{u.player}</span>
                </label>
            ))}
        </div>
    );
};



